import {
  OverlayRef,
  FlexibleConnectedPositionStrategy,
  ConnectedOverlayPositionChange
} from '@angular/cdk/overlay';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { ScPopoverConfig } from './sc-popover-config';

/**
 * Reference to a popover opened via the Popover service.
 */
export class ScPopoverRef<T = any> {
  private afterClosedSubject = new Subject<T>();

  constructor(
    private overlayRef: OverlayRef,
    private positionStrategy: FlexibleConnectedPositionStrategy,
    public config: ScPopoverConfig
  ) {
    if (!config.disableClose) {
      this.overlayRef
        .backdropClick()
        .pipe(takeUntil(this.afterClosedSubject))
        .subscribe(() => {
          this.close();
        });
    }
  }

  close(dialogResult?: T): void {
    this.afterClosedSubject.next(dialogResult);
    this.afterClosedSubject.complete();

    this.overlayRef.dispose();
  }

  afterClosed(): Observable<T> {
    return this.afterClosedSubject.asObservable();
  }

  positionChanges(): Observable<ConnectedOverlayPositionChange> {
    return this.positionStrategy.positionChanges;
  }
}
